export const isSetEqual = <T>(a: Set<T>, b: Set<T>) => (
    (a.size === b.size) && [...a].every(value => b.has(value))
    // a.size === b.size && Array.from(a, (value) => b.has(value)).every(Boolean)
);